//Props Validations
import PropTypes from "prop-types";

function Loader({ message = "Loading", bgColor = "rgba(0, 0, 0, 0.5)", color = "#ffffff" }) {
    return (
        <div
            style={{
                zIndex: 20000,
                backgroundColor: bgColor,
            }}
            className="loader-container"
        >
            {/* <div className="loader">{message === "" ? "Loading" : message }...<span></span></div> */}
            <div id="page">
                <div id="container">
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div
                        id="h3"
                        style={{ color: color }}
                    >
                        {message === "" ? "Loading" : message}...
                    </div>
                </div>
            </div>
        </div>
    );
}

// Typechecking props for the Loader
Loader.propTypes = {
    message: PropTypes.string,
    bgColor: PropTypes.string,
    color: PropTypes.string,
};

export default Loader;
